import React from 'react';
import { cn } from '@/lib/utils';

interface BoxButtonProps {
  active: boolean;
  disabled?: boolean;
  onClick?: () => void;
  children?: React.ReactNode;
}

const BoxButton = (props: BoxButtonProps) => {
  const { active, disabled, children, onClick } = props;
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={cn([
        'w-[30px] h-[25px] rounded-[2px] font-bold text-[1.125rem] text-center leading-[24px] text-venn-primary-dark',
        'ml-[5px] transition-all delay-[0.2s] ease-out border border-solid',
        active ? 'bg-venn-primary-dark/10' : 'bg-venn-white',
        active && !disabled ? 'border-venn-primary-dark' : 'border-venn-grey-20',
        'hover:cursor-pointer hover:text-venn-primary-dark hover:bg-venn-primary-dark/10',
        'disabled:bg-venn-grey disabled:text-venn-grey-60 disabled:cursor-not-allowed disabled:pointer-events-none',
        'print:bg-venn-white print:border-0 print:text-black print:w-[10px] print:h-[100%]',
        active ? 'print:flex' : 'print:hidden',
      ])}
    >
      {children}
    </button>
  );
};

export default BoxButton;
